import { renderSafetyArmadillo, renderPartyPanda, renderDiscoCapybara } from '../utils/mascots.js';
import logger from '../utils/logger.js';
import { escapeHtml } from '../utils/html-utils.js';
import { renderPageTitle } from '../utils/emoji-badge.js';

// Release Notes Web Component
class ReleaseNotes extends HTMLElement {
  constructor() {
    super();
    this.releaseNotes = null;
  }

  async connectedCallback() {
    await this.loadReleaseNotes();
    this.render();
  }

  async loadReleaseNotes() {
    try {
      const response = await fetch('/api/release-notes', {
        credentials: 'include'
      });
      if (!response.ok) {
        throw new Error(`Failed to load release notes: ${response.status}`);
      }
      this.releaseNotes = await response.json();
    } catch (error) {
      logger.error('Error loading release notes:', { error });
      // Fallback to empty array if fetch fails
      this.releaseNotes = [];
    }
  }

  formatDate(dateString) {
    const date = new Date(dateString);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]} ${date.getDate()}`;
  }

  formatFullDate(dateString) {
    const date = new Date(dateString);
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  }

  scrollToVersionHash() {
    const hash = window.location.hash;
    if (!hash || !hash.startsWith('#v')) {
      return;
    }

    const target = this.querySelector(hash);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  renderRelease(release) {
    const dateFormatted = this.formatDate(release.date);
    const dateFull = this.formatFullDate(release.date);
    const versionId = `v${release.version}`;

    // Handle special mascot rendering for version 1.0
    let content = release.content;
    if (release.version === '1.0') {
      // Replace placeholder comments with actual mascot renders
      content = content.replace(
        '<!-- Safety Armadillo will be rendered here -->',
        renderSafetyArmadillo()
      );
      content = content.replace(
        '<!-- Party Panda will be rendered here -->',
        renderPartyPanda()
      );
      content = content.replace(
        '<!-- Disco Capybara will be rendered here -->',
        renderDiscoCapybara()
      );
    }

    return `
      <section class="release" id="${versionId}">
        <div class="release-header">
          ${renderPageTitle('📅', `Version ${escapeHtml(release.version)} - "${escapeHtml(release.codename)}"`)}
          <time datetime="${release.date}" title="${dateFull}">${dateFormatted}</time>
        </div>
        ${release.summary ? `<p>${release.summary}</p>` : ''}
        <div class="release-content">
          ${content}
        </div>
      </section>
    `;
  }

  render() {
    if (!this.releaseNotes || this.releaseNotes.length === 0) {
      this.innerHTML = `
        <article class="public-page release-notes-page" aria-label="Release Notes">
          <header>
            <p>🎉 All the fun stuff we've been building!</p>
            <h1>Release Notes</h1>
            <p>Your friendly changelog of whimsy and wonder</p>
          </header>
          <p>Loading release notes...</p>
        </article>
      `;
      return;
    }

    const releasesHtml = this.releaseNotes.map(release => this.renderRelease(release)).join('\n');

    this.innerHTML = `
      <article class="public-page release-notes-page" aria-label="Release Notes">
        <header>
          <p>🎉 All the fun stuff we've been building!</p>
          <h1>Release Notes</h1>
          <p>Your friendly changelog of whimsy and wonder</p>
        </header>

        ${releasesHtml}

        <section class="release-footer">
          <p>💡 Have ideas for future releases? We'd love to hear them! Click on the Safety Armadillo in the Taco Menu. The best features come from our community.</p>
        </section>
      </article>
    `;

    this.scrollToVersionHash();
  }
}

customElements.define('release-notes', ReleaseNotes);

